<ng-container *transloco="let t; prefix: 'PremiseHazard'">
  <form [formGroup]="PremiseHazardForm" (ngSubmit)="onSubmit()" [disabled]a="IsSubmitting" class="edit-container">
    <div class="edit-container-header">
      <button type="button" pButton (click)="cancelClicked()"><msi-icon name="ic_back" /></button>
      <ng-container [ngTemplateOutlet]="formButtons"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>
    </div>
    <div class="edit-container-body">
      <label class="msi-label msi-margin-bottom-s">
        {{
        IsCreating ? t('Item.header.creating') : t('Item.header.modifying')
        }}
      </label>
      <ng-container [ngTemplateOutlet]="recordTitleForm"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="priority"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="typeForm"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm, EmptyId: EmptyId }"></ng-container>

      <ng-container [ngTemplateOutlet]="addressForm"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="comments"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="contacts"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="attachmentNotes"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="authorizingPersonnel"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="ownerInformation"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>

      <ng-container [ngTemplateOutlet]="temporaryHazard"
                    [ngTemplateOutletContext]="{ form: PremiseHazardForm }"></ng-container>
    </div>
  </form>

  <ng-template #typeForm let-form="form" let-emptyId="EmptyId">
    <div [formGroup]="form">
      <label class="msi-label">
        {{ t('label.hazardType') }}
        @if (!form.controls['premiseHazardTypeId'].valid || form.controls.premiseHazardTypeId.value === EmptyId) {
        <msi-icon name="ic_error" class="error_icon" msiTooltip="{{ 'General.fieldIsRequired' | transloco }}" />
        }
      </label>
      <div class="input-container">
        <p-autocomplete [(ngModel)]="SelectedTypeOption"
                        [ngModelOptions]="{ standalone: true }"
                        [loading]="IsAutocompleteLoading"
                        (onSelect)="onPremiseHazardTypeSelected($event)"
                        [suggestions]="PremiseHazardTypeFilteredOptions"
                        field="displayValue"
                        [minLength]="0"
                        [showClear]="true"
                        (completeMethod)="onTypeInputChanged($event)"
                        (onClear)="onPremiseHazardTypeInputCleared()"
                        (onFocus)="showTypeDropdown()"
                        #PremiseHazardTypeAutocomplete
                        class="msi-margin-s full-width-input"
                        placeholder="{{ t('placeholder.noTypeSelected') }}" />
      </div>
    </div>
  </ng-template>

  <ng-template #addressForm let-form="form">
    <label class="msi-label">
      {{ t('label.address') }}
      @if (!form.controls.addressId.value && !isCreatingAddress) {
      <msi-icon name="ic_error" class="error_icon" />
      }
    </label>
    <div class="form-row">
      <div class="input-container">
        @if (isCreatingAddress) {
        <label class="msi-label">
          {{
            t('Item.text.creatingAddress', {
              address: selectedAddressCandidate?.matchLocation?.houseAddress,
            })
          }}
        </label>
        } @else {
        <p-autocomplete [(ngModel)]="SelectedAddressOption"
                        [ngModelOptions]="{ standalone: true }"
                        [loading]="IsAutocompleteLoading"
                        (onSelect)="onExistingAddressSelected($event)"
                        [suggestions]="AddressFilteredOptions"
                        field="displayValue"
                        [minLength]="0"
                        [showClear]="true"
                        (completeMethod)="onAddressInputChanged($event)"
                        (onClear)="onAddressInputCleared()"
                        #AddressAutocomplete
                        placeholder="{{ t('placeholder.addressRequired') }}"
                        class="msi-margin-s full-width-input" />
        }
      </div>
      <div>
        @if (isCreatingAddress) {
        <button type="button"
                [pTooltip]="t('Item.tooltip.clearAddress')"
                pButton
                [outlined]="true"
                class="msi-margin-left-s msi-margin-right-s"
                (click)="clearAddressClicked()">
          <msi-icon name="ic_remove" class="delete-icon" />{{ t('Item.button.changeAddress') }}
        </button>
        } @else {
        <button type="button"
                pButton
                [text]="true"
                class="msi-margin-left-s msi-margin-right-s"
                (click)="openSuggestModal()">
          <msi-icon name="ic_add" />{{ t('Item.button.lookupAddress') }}
        </button>
        }
      </div>
    </div>
  </ng-template>

  <ng-template #recordTitleForm let-form="form">
    <div [formGroup]="form">
      <div class="edit-form-label-row">
        <label class="msi-label">{{ t('label.title') }}</label>
        @if (!form.controls['recordTitle'].valid) {
        <msi-icon name="ic_error" class="error_icon" msiTooltip="{{ 'General.fieldIsRequired' | transloco }}" />
        }
      </div>
      <div class="input-container">
        <input pInputText
               class="msi-margin-s full-width-input"
               placeholder="{{ t('placeholder.name') }}"
               formControlName="recordTitle" />
      </div>
      @if (!PremiseHazardForm.controls['recordTitle'].valid && PremiseHazardForm.controls['recordTitle'].touched) {
      <div>
        <div style="color: red">{{ 'General.fieldIsRequired' | transloco }}</div>
      </div>
      }
    </div>
  </ng-template>

  <ng-template #priority let-form="form">
    <div [formGroup]="form">
      <div class="flex-container-row">
        <label class="msi-label">{{ t('label.priority') }}</label>
        @if (!form.controls.priority.value) {
        <msi-icon name="ic_error" class="error_icon" msiTooltip="{{ 'General.fieldIsRequired' | transloco }}" />
        }
      </div>
      <div class="input-container">
        <p-select class="msi-margin-s full-width-input"
                  placeholder="{{ t('placeholder.priority') }}"
                  formControlName="priority"
                  [options]="PRIORITY_TYPES">
          <ng-template pTemplate="selectedItem" let-value>{{ value | titlecase }}</ng-template>
          <ng-template pTemplate="item" let-opt>{{ opt | titlecase }}</ng-template>
        </p-select>
      </div>
      @if (!PremiseHazardForm.controls['priority'].valid && PremiseHazardForm.controls['priority'].touched) {
      <div>
        <div style="color: red">{{ 'General.fieldIsRequired' | transloco }}</div>
      </div>
      }
    </div>
  </ng-template>
  <ng-template #authorizingPersonnel let-form="form">
    <div [formGroup]="form">
      <label class="msi-label">{{ t('label.authorizingPersonnel') }}</label>
      <div class="input-container">
        <input pInputText
               class="msi-margin-s full-width-input"
               placeholder="{{ t('placeholder.authorizingPersonnel') }}"
               formControlName="authorizingPersonnel" />
      </div>
      <div class="msi-checkbox-row">
        <p-checkbox [binary]="true" inputId="isReviewRequired" formControlName="isReviewRequired" /><label for="isReviewRequired">{{ t('label.reviewRequired') }}</label>
      </div>
    </div>
  </ng-template>
  <ng-template #ownerInformation let-form="form">
    <div [formGroup]="form">
      <label class="msi-label">{{ t('label.ownerInformation') }}</label>
      <label class="msi-label">{{ t('label.name') }}</label>
      <div class="input-container">
        <input pInputText
               class="msi-margin-s full-width-input"
               placeholder="{{ t('placeholder.ownerName') }}"
               formControlName="ownerName" />
      </div>
      <label class="msi-label">{{ t('label.ownerPhone') }}</label>
      <div class="input-container">
        <input pInputText
               class="msi-margin-s full-width-input"
               placeholder="{{ t('placeholder.ownerPhone') }}"
               formControlName="ownerPhone" />
      </div>
      <label class="msi-label">{{ t('label.ownerAddress') }}</label>
      <div class="input-container">
        <input pInputText
               class="msi-margin-s full-width-input"
               placeholder="{{ t('placeholder.ownerAddress') }}"
               formControlName="ownerAddress" />
      </div>
    </div>
  </ng-template>

  <ng-template #temporaryHazard let-form="form">
    <div [formGroup]="form">
      <label class="msi-label">
        {{ t('label.temporaryConfiguration') }}
      </label>
      <div class="msi-checkbox-row">
        <p-checkbox [binary]="true" inputId="isTemporary" formControlName="isTemporary" /><label for="isTemporary">
          {{
          t('label.temporaryHazard')
          }}
        </label>
      </div>
      @if (PremiseHazardForm.get('isTemporary')?.value) {
      <div class="msi-padding-m">
        <label class="msi-label">{{ t('label.purgeDate') }}</label>
        <div class="input-container">
          <p-datepicker class="msi-margin-s full-width-input"
                        formControlName="purgeDate"
                        dateFormat="yy-mm-dd"
                        [showIcon]="true"
                        [readonlyInput]="true"
                        [minDate]="minDate" />
        </div>
        <label class="msi-label">{{ t('label.purgeType') }}</label>
        <div class="input-container">
          <p-select class="msi-margin-s full-width-input"
                    placeholder="{{ t('placeholder.purgeType') }}"
                    formControlName="purgeType"
                    [options]="PURGE_TYPES" />
        </div>
      </div>
      }
    </div>
  </ng-template>

  <ng-template #comments let-form="form">
    <label class="msi-label">{{ t('label.comments') }}</label>
    <div [formGroup]="form" class="input-container">
      <textarea pTextarea
                class="msi-margin-s full-width-input"
                placeholder="{{ t('placeholder.comments') }}"
                formControlName="comments"></textarea>
    </div>
  </ng-template>

  <ng-template #contacts let-form="form">
    <app-premise-hazard-item-contacts [SelectedPremiseHazard]="SelectedPremiseHazard"
                                      [IsUpdating]="IsUpdating"
                                      (contactsChanged)="onContactsChanged($event)">
    </app-premise-hazard-item-contacts>
  </ng-template>

  <ng-template #attachmentNotes>
    <label class="msi-label">
      {{ t('label.attachments') }}
    </label>
    <div>
      {{ t('Item.text.attachments') }}
    </div>
  </ng-template>

  <ng-template #formButtons let-form="form">
    <div [formGroup]="form" class="edit-toolbar-right">
      <button type="button" pButton (click)="cancelClicked()" [disabled]="IsSubmitting">
        <msi-icon name="ic_remove" class="delete-icon" />{{ 'Buttons.cancel' | transloco }}
      </button>
      <button pButton type="submit" [disabled]="IsSubmitting || !form.valid">
        @if (IsSubmitting) {
        <p-progress-spinner class="justify-content-center" />
        }
        <msi-icon name="ic_add" />{{ 'Buttons.save' | transloco }}
      </button>
    </div>
  </ng-template>
</ng-container>
